import React, {useEffect, useState} from 'react'
import DHButtonSave from "../../../general/DHButtonSave";
import {Tooltip} from "@mui/material";
import DomainVerificationIcon from '@mui/icons-material/DomainVerification';
import DHDialog from "../../../general/DHDialog";
import DHNumberTextField from "../../../general/DHNumberTextField";
import ConfigUtil from "../../../../util/ConfigUtil";
import FetchUtil from "../../../../util/FetchUtil";
import ErrorInfoComponent from "../../../general/ErrorInfoComponent";
import ConfirmWithQuestionDialog from "../../../general/ConfirmWithQuestionDialog";

export default function ErgebnisKurzComp({spiel, onRefresh}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [showDialog, setShowDialog] = useState(false);
    const [heimSpiele, setHeimSpiele] = useState(undefined);
    const [gastSpiele, setGastSpiele] = useState(undefined);
    const [heimLegs, setHeimLegs] = useState(undefined);
    const [gastLegs, setGastLegs] = useState(undefined);
    const [working, setWorking] = useState(false);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);

    useEffect(() => {
        setHeimSpiele(spiel.anzahlHeim);
        setGastSpiele(spiel.anzahlGast);
        setHeimLegs(spiel.anzahlHeimLegs);
        setGastLegs(spiel.anzahlGastLegs);
    }, [spiel]);

    const loeschen = () => {
        saveIntern(undefined, undefined, undefined, undefined, "Löschen erfolgreich...");
        setShowDialog(false);
        setShowDeleteDialog(false);
    }

    const save = () => {
        saveIntern(heimSpiele, gastSpiele, heimLegs, gastLegs, "Speichern erfolgreich...");
    }

    const saveIntern = (tmpHeimSpiele, tmpGastSpiele, tmpHeimLegs, tmpGastLegs, message) => {
        setErrorMessage(undefined);
        setWorking(true);
        let data = {heimGewonnen : tmpHeimSpiele, gastGewonnen: tmpGastSpiele, heimLegs: tmpHeimLegs, gastLegs: tmpGastLegs}
        let url = ConfigUtil.getConfig().resourceUrls.league + "/liga/spiel/ergebnis/kurz/save/" + spiel.id;
        FetchUtil.fetchPost(url,
            data,
            () => {
                setInfoMessage(message);
                setWorking(false);
                onRefresh();
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
                setWorking(false);
            },
            error => {
                setErrorMessage("Fehler: " + error.message)
                setWorking(false);
            });
    }

    const isSaveDisabled = () => {
        return !heimSpiele || !gastSpiele || !heimLegs || !gastLegs
    }

    const getDataArea = () => {
        return <div>
            <div style={{marginBottom: 20}}>
                <DHNumberTextField label="Gewonnene Spiele - Heimannschaft" value={heimSpiele} showPlaceholder={false}
                                   min={0} max={100} width={400} required={true} id="id-heim-gewonnene-spiele"
                                   onChange={(value) => setHeimSpiele(value)}/>
            </div>
            <div style={{marginBottom: 50}}>
                <DHNumberTextField label="Gewonnene Spiele - Gastmannschaft" value={gastSpiele} showPlaceholder={false}
                                   min={0} max={100} width={400} required={true} id="id-gast-gewonnene-spiele"
                                   onChange={(value) => setGastSpiele(value)}/>
            </div>
            <div style={{marginBottom: 20}}>
                <DHNumberTextField label="Gewonnene Legs - Heimannschaft" value={heimLegs} showPlaceholder={false}
                                   min={0} max={100} width={400} required={true} id="id-heim-gewonnene-legs"
                                   onChange={(value) => setHeimLegs(value)}/>
            </div>
            <div style={{marginBottom: 50}}>
                <DHNumberTextField label="Gewonnene Legs - Gastmannschaft" value={gastLegs} showPlaceholder={false}
                                   min={0} max={100} width={400} required={true} id="id-gast-gewonnene-legs"
                                   onChange={(value) => setGastLegs(value)}/>
            </div>
            <div>
                <DHButtonSave label="Ergebnis löschen" working={working} onClick={() => setShowDeleteDialog(true)} disabled={false}/>,
            </div>
        </div>
    }

    return <>
        <Tooltip title="Kurzerfassung - Ergebnis eintragen/ändern">
            <DomainVerificationIcon style={{marginRight: 10, cursor: "pointer"}} onClick={() => setShowDialog(true)}/>
        </Tooltip>
        {showDialog && <DHDialog showCloseButton={true} title="Kurzerfassung - Ergebnis eintragen/ändern" onClose={() => setShowDialog(false)}
                                 buttons={
            [<DHButtonSave working={working} onClick={() => save()} disabled={isSaveDisabled()}/>]}
                                 comp={<>
                                     <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)}
                                                         onClearErrorMessage={() => setErrorMessage(undefined)}/>
                                     {getDataArea()}
                                 </>}/>
        }
        {showDeleteDialog && <ConfirmWithQuestionDialog header="Löschen?"
                                                        visible={true}
                                                        textOben="Beim Löschen wird das Ergebnis und evtl. Detailergebnisse unwiderruflich gelöscht."
                                                        textUnten="Möchtest du wirklich löschen?"
                                                        callBackOnJa={() => loeschen()}
                                                        callBackOnNein={() => setShowDeleteDialog(false)}/>
        }
    </>
}